import { faArrowRight as fasArrowRight, faClock as fasClock } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { FormApi } from "final-form";
import type { ReactNode } from "react";
import { Card } from "react-bootstrap";
import { AbstractStep } from "@/component/assets/AbstractLeadForm/Steps/AbstractStep";
import { ButtonLegacy, FormCurrency, FormSelect } from "@/shared/ui";
import { PRODUCT_REQUISITION_TIME } from "./Step5.data";

export interface Step5Fields {
	currentLoansMonthlyInstallment: number;
	creditLimitSumValue: number;
	productRequisitionTime: string;
}

export class Step5 extends AbstractStep<Step5Fields> {
	protected initValues(): Step5Fields {
		return {
			currentLoansMonthlyInstallment: undefined,
			creditLimitSumValue: undefined,
			productRequisitionTime: undefined,
		};
	}

	protected renderContent(_values: Step5Fields, form: FormApi<Step5Fields>): ReactNode {
		return (
			<>
				<Card.Body>
					<FormCurrency
						label="Hány forint a jelenlegi hitelek összes havi törlesztőrészlete?"
						name="currentLoansMonthlyInstallment"
						infoTooltip="A háztartás összes havi törlesztőrészlete, pl. személyi kölcsön, áruhitel, diákhitel, autóhitel, munkáltatói kölcsön, lakáshitel, stb."
						placeholder="Ha nincs, írj be 0-át!"
						validate={this.validAmount}
						required
					/>
					<FormCurrency
						label="Hány forint a hitelkártyák, hitelkeretek teljes, kihasználható összege?"
						name="creditLimitSumValue"
						infoTooltip="A háztartás összes hitelkeretét bele kell számolni akkor is, ha nincs kihasználva."
						placeholder="Ha nincs, írj be 0-át!"
						validate={this.validAmount}
						required
					/>
					<FormSelect
						label="Mikor szeretnéd igényelni a Babaváró hitelt?"
						name="productRequisitionTime"
						placeholder="Válassz a listából!"
						options={PRODUCT_REQUISITION_TIME}
						prepend={<FontAwesomeIcon icon={fasClock} />}
						required
					/>
				</Card.Body>
				<Card.Footer className="text-center">
					<ButtonLegacy
						type="submit"
						icon={<FontAwesomeIcon icon={fasArrowRight} />}
						className={!form.getState().valid ? "disabled" : undefined}
					>
						Tovább
					</ButtonLegacy>
				</Card.Footer>
			</>
		);
	}

	private validAmount(amount: number): string {
		if (isNaN(amount) || amount < 0) {
			return "Helytelen összeg!";
		}

		return undefined;
	}

	protected getComponentName(): string {
		return "Step5";
	}
}
